import { render, staticRenderFns } from "./envelope-documents.vue?vue&type=template&id=50eff7c0"
import script from "./envelope-documents.vue?vue&type=script&lang=js"
export * from "./envelope-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports